import { defineNuxtPlugin } from '#app/nuxt'
import { LazyMarkdownBlockly, LazyRenderCacheable } from '#components'
const lazyGlobalComponents = [
  ["MarkdownBlockly", LazyMarkdownBlockly],
["RenderCacheable", LazyRenderCacheable],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
